import React from 'react';
import { TableRow } from '@material-ui/core';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { DEFAULT_TABLE_ROW_HEIGHT, HoverLink, LoaderRow, TableCell, Typography } from '../../../../ui-kit';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { useUser } from '../../../../utils/hooks/auth';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { DeliveryLists } from './types';
import { deliveryListsHeadCells } from './constants';

interface DeliveryListsTableContentProps {
    deliveryLists: DeliveryLists;
    isLoading: boolean;
    rowsPerPage: number;
}

const DeliveryListsTableContent = ({ deliveryLists, isLoading, rowsPerPage }: DeliveryListsTableContentProps) => {
    const match = useRouteMatch();
    const { user: { cultureCode, defaultCurrency: { currencyCode } } } = useUser();
    const { priceService } = usePriceService();
    const { dateTimeService } = useDateTimeService();
    const history = useHistory();
    const referrer = history.location.pathname;

    return isLoading
        ? <LoaderRow columnCount={deliveryListsHeadCells.length} itemsPerPage={rowsPerPage} itemHeight={DEFAULT_TABLE_ROW_HEIGHT} />
        : (
            <>
                {deliveryLists.map(row => (
                    <TableRow tabIndex={-1} key={row.id}>
                        {deliveryListsHeadCells.map((cell, index) => {
                            let cellValue: React.ReactNode;
                            if (cell.id === 'deliveryDateUtc') {
                                const deliveryListUrl = `${match.url}/${row.id}`;

                                cellValue = (
                                    <HoverLink wide to={{ pathname: deliveryListUrl, state: { referrer } }}>
                                        {dateTimeService.localizeDate(row[cell.id], cultureCode)}
                                    </HoverLink>
                                );
                            } else if (cell.id === 'deliveryListItemsTotalCost') {
                                cellValue = priceService.toLocaleString(row[cell.id], currencyCode);
                            } else if (cell.id === 'supplier') {
                                cellValue = row.supplier.legalName;
                            } else {
                                cellValue = row[cell.id];
                            }
                            return (
                                <TableCell align={cell.align} isSticky={index === 0} key={`${cell.id} - ${row.id}`}>
                                    <Typography variant='body2'>{cellValue}</Typography>
                                </TableCell>
                            );
                        })}
                    </TableRow>
                ))}
            </>
        );
};

export default DeliveryListsTableContent;
